var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#9989f9",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.6944,0.6944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M184.333,0c-82.323,0 -149.297,66.974 -149.297,149.297c0,33.969 11.132,65.96 32.193,92.515c27.27,34.383 106.572,116.021 109.934,119.479l7.169,7.375l7.17,-7.374c3.364,-3.46 82.69,-85.116 109.964,-119.51c21.042,-26.534 32.164,-58.514 32.164,-92.485c0,-82.323 -66.974,-149.297 -149.297,-149.297zM285.795,229.355c-21.956,27.687 -80.92,89.278 -101.462,110.581c-20.54,-21.302 -79.483,-82.875 -101.434,-110.552c-18.228,-22.984 -27.863,-50.677 -27.863,-80.087c0,-71.295 58.002,-129.297 129.297,-129.297c71.294,0 129.297,58.002 129.296,129.297c0,29.412 -9.625,57.096 -27.834,80.058z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.333,59.265c-48.73,0 -88.374,39.644 -88.374,88.374c0,48.73 39.645,88.374 88.374,88.374c48.729,0 88.374,-39.645 88.374,-88.374c0,-48.729 -39.644,-88.374 -88.374,-88.374zM184.333,216.013c-37.702,0 -68.374,-30.673 -68.374,-68.374c0,-37.702 30.673,-68.374 68.374,-68.374c37.701,0 68.373,30.673 68.374,68.374c0,37.702 -30.672,68.374 -68.374,68.374z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.e678ffdca6d91a92736de2163e910c43.svg";
export { ForwardRef as ReactComponent };